import { Injectable } from '@angular/core';
import { OverlayPreCargaModel } from '../models/overlay-pre-carga.model';
import { PreCargaModel } from '../models/pre-carga.model';
import { MapUtilsService } from './map-utils.service';
import { MarkerAGM } from '../models/marker-agm';

@Injectable({
  providedIn: 'root'
})
export class OverlayPreCargaService {

  overlaysPreCargas: OverlayPreCargaModel[] = [];

  constructor(private mapUtilService: MapUtilsService) { }

  adicionarOverlay(over, preCarga: PreCargaModel) {
    this.overlaysPreCargas.push({ overlay: over, preCargaModel: preCarga });
  }

  removerOverlay(preCarga: PreCargaModel) {
    const index = this.overlaysPreCargas.findIndex(o => o.preCargaModel.id === preCarga.id);
    const over = this.overlaysPreCargas[index];

    if (over && over.overlay) {
      // Acao comentada devido ao fluxo de tranferencia.
      // A entrega/pedido transferido para outra preCarga nao estara presente no overlay
      this.mapUtilService.removerMap(over.overlay);
      this.overlaysPreCargas.splice(index, 1);
    } else {
      preCarga.listaMarkers.forEach(marker => this.redefinirMarker(marker));
    }
  }

  private redefinirMarker(m: MarkerAGM): void {
    m.overlayPreCarga = null;
    this.mapUtilService.redefinirMarkerAGMEstadoInicial(m);
  }

  limparOverlayTodasPreCargas() {
    this.overlaysPreCargas.forEach(over => {
      this.mapUtilService.removerMap(over.overlay);
    });

    this.overlaysPreCargas = [];
  }

  obterOverlayPelaPreCargaModel(preCarga: PreCargaModel): google.maps.OverlayView {
    const over = this.overlaysPreCargas.filter(o => o.preCargaModel.id === preCarga.id);

    return over && over[0] ? over[0].overlay : null;
  }

}
